import { useThemeColors } from '@/shared/theme/useThemeColors';
import { typography } from '@/shared/theme/tokens';

/**
 * EmptyState — zero-data placeholder used across list/table views.
 *
 * Props:
 *   icon        — material-symbols name (default 'inbox')
 *   title       — heading text
 *   description — body text (optional)
 *   action      — optional React node (e.g. a button)
 */
export function EmptyState({ icon = 'inbox', title, description, action }) {
  const c = useThemeColors();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 40px',
      textAlign: 'center',
    }}>
      <span
        className="material-symbols-outlined"
        style={{
          fontSize: 48,
          color: c.textSubtle,
          display: 'block',
          marginBottom: '16px',
          fontVariationSettings: "'FILL' 0",
        }}
      >
        {icon}
      </span>

      {title && (
        <h3 style={{
          margin: '0 0 6px',
          fontSize: typography.fontSize.xl,
          fontWeight: typography.fontWeight.bold,
          color: c.textLabel,
          fontFamily: typography.fontFamily.heading,
        }}>
          {title}
        </h3>
      )}

      {description && (
        <p style={{
          margin: 0,
          fontSize: typography.fontSize.md,
          color: c.textSubtle,
          maxWidth: '320px',
          lineHeight: 1.6,
        }}>
          {description}
        </p>
      )}

      {action && (
        <div style={{ marginTop: '20px' }}>
          {action}
        </div>
      )}
    </div>
  );
}
